import { useMemo } from "react"
import { Table } from "antd"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import usePlacementColumns from "../hooks/usePlacementColumns"
import { sortPlacementRows } from "../hooks/helpers/placementRows.helper"
import { IPlacementDataForUpdate } from "../store/types/placements"
import { IPlacementDataTable } from "../types/placement"

interface IPlacementsTableProps {
  placementsDataTable: IPlacementDataTable[]
  handleLimitedCPCChange: (placement: IPlacementDataTable, value: number) => void
  handleTargetAcosChange: (placement: IPlacementDataTable, value: number) => void
  setPlacementsDataForUpdate: React.Dispatch<React.SetStateAction<IPlacementDataForUpdate[]>>
}

const PlacementsTable: React.FC<IPlacementsTableProps> = ({
  placementsDataTable,
  handleLimitedCPCChange,
  handleTargetAcosChange,
  setPlacementsDataForUpdate,
}) => {
  const { isLoading: placementsLoaded } = useTypedSelector((select) => select.placements)

  const columns = usePlacementColumns({
    handleLimitedCPCChange,
    handleTargetAcosChange,
    setPlacementsDataForUpdate,
  })

  const orderedPlacements = useMemo(
    () => sortPlacementRows(placementsDataTable),
    [placementsDataTable]
  )

  return (
    <Table
      columns={columns}
      dataSource={orderedPlacements}
      pagination={false}
      scroll={{ x: "max-content" }}
      bordered
      rowKey="placement"
      size="small"
      loading={placementsLoaded}
      showHeader={false}
    />
  )
}

export default PlacementsTable
